"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const types_1 = require("./types");
const prop_types_1 = __importDefault(require("prop-types"));
const SankeyUtils_1 = require("./SankeyUtils");
const SankeyLinkEditionPropTypes = {
    data: prop_types_1.default.shape(types_1.SankeyDataPropTypes).isRequired,
    set_data: prop_types_1.default.func.isRequired,
    //selected_link: PropTypes.shape(SankeyLinkPropTypes).isRequired,
    selected_link: prop_types_1.default.shape({ current: prop_types_1.default.shape(types_1.SankeyLinkPropTypes).isRequired }).isRequired,
    show: prop_types_1.default.bool.isRequired,
    multi_selected_links: prop_types_1.default.shape({ current: prop_types_1.default.arrayOf(prop_types_1.default.shape(types_1.SankeyLinkPropTypes).isRequired).isRequired }).isRequired,
};
const SankeyLinkEdition = ({ data, set_data, selected_link, multi_selected_links, children }) => {
    const { fluxTags, dataTags } = data;
    const tags_visible = Object.keys(fluxTags).length > 0;
    const [tags_group_key, set_tags_group_key] = (0, react_1.useState)(tags_visible ? Object.keys(fluxTags)[0] : '');
    if ((tags_group_key == '' && Object.keys(fluxTags).length > 0) || (!Object.keys(fluxTags).includes(tags_group_key) && Object.keys(fluxTags).length > 0)) {
        set_tags_group_key(Object.keys(fluxTags)[0]);
    }
    let link = selected_link.current;
    if (link === undefined) {
        link = (0, SankeyUtils_1.default_link)(data);
    }
    const newEntries = new Map(Object.entries(dataTags).map(([dataTagKey, dataTag]) => {
        return (Object.keys(dataTag.tags).length > 0) ? [
            dataTagKey,
            Object.entries(dataTag.tags).filter(tag => tag[1].selected).length > 0 ? Object.entries(dataTag.tags).filter(tag => tag[1].selected)[0][0] : Object.keys(dataTag.tags)[0]
        ] : ['n', 'n'];
    }));
    //Créer un objet contenant la clé de chaque dataTag avec pour valeur la première tag de ces groupe
    const dataTagsSelected = Object.fromEntries(newEntries);
    //supprime les groupe tag qui n'ont pas de tag car on ne peux pas choisir de tags pour affecter une valeur au flux
    delete dataTagsSelected['n'];
    const [tags_selected, set_tags_selected] = (0, react_1.useState)(dataTagsSelected);
    if (Object.keys(tags_selected).length !== Object.keys(dataTagsSelected).length) {
        set_tags_selected(dataTagsSelected);
    }
    //renvoie la valeur correspondant aux paramètre selectionné
    const value_selected_parameter = () => {
        if (Object.keys(data.links).length === 0 || !(multi_selected_links.current[0].idLink in data.links)) {
            let val = JSON.parse(JSON.stringify(Object(multi_selected_links.current[0].value)));
            Object.values(tags_selected).map(tag_selected => {
                if (val[tag_selected] === undefined) {
                    val[tag_selected] = {};
                }
                val = val[tag_selected];
            });
            return val;
        }
        let val = JSON.parse(JSON.stringify(Object(data.links[multi_selected_links.current[0].idLink].value)));
        Object.values(tags_selected).map(tag_selected => {
            if (val[tag_selected] === undefined) {
                val[tag_selected] = { 'display_value': '', tags: {}, value: 0 };
            }
            val = val[tag_selected];
        });
        return val;
    };
    const test_value = (v) => {
        return ((v || v === 0) && v !== undefined) ? v : '';
    };
    const center = selected_link.current.left_horiz_shift && selected_link.current.right_horiz_shift ? (selected_link.current.left_horiz_shift + selected_link.current.right_horiz_shift) / 2 : 0.5;
    // DEFINITION DES FONCTIONS VERIFIANT QUE TOUTES LES VALEURS DES DIFÉRENTS PARAMÈTRES SOIENT IDENTIQUES 
    const gradChecked = () => {
        let gradChecked = true;
        multi_selected_links.current.map(d => {
            gradChecked = (d.gradient) ? gradChecked : false;
        });
        return gradChecked;
    };
    const dashChecked = () => {
        let dashChecked = true;
        multi_selected_links.current.map(d => {
            dashChecked = (d.dashed) ? dashChecked : false;
        });
        return dashChecked;
    };
    const labelVisibleChecked = () => {
        let labelVisibleChecked = true;
        multi_selected_links.current.map(d => {
            labelVisibleChecked = (d.label_visible) ? labelVisibleChecked : false;
        });
        return labelVisibleChecked;
    };
    const shiftCenter = () => {
        let display_shift = true;
        let center = 0.5;
        if (multi_selected_links.current.length != 0) {
            center = multi_selected_links.current[0].left_horiz_shift && multi_selected_links.current[0].right_horiz_shift ? (multi_selected_links.current[0].left_horiz_shift + multi_selected_links.current[0].right_horiz_shift) / 2 : 0.5;
        }
        multi_selected_links.current.map((d) => {
            const tmp = d.left_horiz_shift && d.right_horiz_shift ? (d.left_horiz_shift + d.right_horiz_shift) / 2 : 0.5;
            display_shift = (tmp == center) ? display_shift : false;
        });
        return (display_shift) ? center : 0;
    };
    const shift = () => {
        let display_shift = true;
        let shift = 0.5;
        if (multi_selected_links.current.length != 0) {
            shift = multi_selected_links.current[0].shift_gap;
        }
        multi_selected_links.current.map((d) => {
            display_shift = (d.shift_gap == shift) ? display_shift : false;
        });
        return (display_shift) ? shift : 0;
    };
    const linkOrientation = (param) => {
        let allChecked = true;
        switch (param) {
            case 'hh':
                multi_selected_links.current.map(d => {
                    allChecked = (d.orientation == 'hh') ? allChecked : false;
                });
                return allChecked;
                break;
            case 'vv':
                multi_selected_links.current.map(d => {
                    allChecked = (d.orientation == 'vv') ? allChecked : false;
                });
                return allChecked;
                break;
            case 'hv':
                multi_selected_links.current.map(d => {
                    allChecked = (d.orientation == 'hv') ? allChecked : false;
                });
                return allChecked;
                break;
            case 'vh':
                multi_selected_links.current.map(d => {
                    allChecked = (d.orientation == 'vh') ? allChecked : false;
                });
                return allChecked;
                break;
        }
    };
    const courbure = () => {
        let display_courbe = true;
        let courbe = 0.5;
        if (multi_selected_links.current.length != 0) {
            courbe = multi_selected_links.current[0].curvature;
        }
        multi_selected_links.current.map((d) => {
            display_courbe = (d.curvature == courbe) ? display_courbe : false;
        });
        return (display_courbe) ? courbe : 0;
    };
    const linkType = (param) => {
        let allChecked = true;
        if (multi_selected_links.current.length != 0) {
            switch (param) {
                case 'courbe':
                    multi_selected_links.current.map(d => {
                        allChecked = (d.curved) ? allChecked : false;
                    });
                    break;
                case 'arrow':
                    multi_selected_links.current.map(d => {
                        allChecked = (d.arrow) ? allChecked : false;
                    });
                    break;
                case 'recycle':
                    multi_selected_links.current.map(d => {
                        allChecked = (d.recycling) ? allChecked : false;
                    });
                    break;
            }
            return allChecked;
        }
        else {
            return false;
        }
    };
    const linkLabelColor = (param) => {
        let allChecked = true;
        if (multi_selected_links.current.length != 0) {
            switch (param) {
                case 'white':
                    multi_selected_links.current.map(d => {
                        allChecked = (d.text_color == 'white') ? allChecked : false;
                    });
                    break;
                case 'black':
                    multi_selected_links.current.map(d => {
                        allChecked = (d.text_color == 'black') ? allChecked : false;
                    });
                    break;
                case 'color':
                    multi_selected_links.current.map(d => {
                        allChecked = (d.text_color == d.color) ? allChecked : false;
                    });
                    break;
            }
            return allChecked;
        }
        else {
            return false;
        }
    };
    const labelPositionVert = (param) => {
        let allChecked = true;
        if (multi_selected_links.current.length != 0) {
            switch (param) {
                case 'beginning':
                    multi_selected_links.current.map(d => {
                        allChecked = (d.label_position == 'beginning') ? allChecked : false;
                    });
                    break;
                case 'middle':
                    multi_selected_links.current.map(d => {
                        allChecked = (d.label_position == 'middle') ? allChecked : false;
                    });
                    break;
                case 'end':
                    multi_selected_links.current.map(d => {
                        allChecked = (d.label_position == 'end') ? allChecked : false;
                    });
                    break;
            }
            return allChecked;
        }
        else {
            return false;
        }
    };
    // const labelSticktoLink = () => {
    //   let labelSticktoLink = true
    //   multi_selected_links.current.map(d => {
    //     labelSticktoLink = (d.label_on_path && d.label_position !== 'frozen') ? labelSticktoLink : false
    //   })
    //   return labelSticktoLink
    // }
    const labelSticktoLinkDisabled = () => {
        let labelSticktoLink = false;
        multi_selected_links.current.map(d => {
            labelSticktoLink = (d.label_on_path) ? true : labelSticktoLink;
        });
        return labelSticktoLink;
    };
    const labelLinkFree = () => {
        let labelLinkFree = false;
        multi_selected_links.current.map(d => {
            labelLinkFree = (d.label_position === 'frozen' && d.orthogonal_label_position === 'frozen') ? true : labelLinkFree;
        });
        return labelLinkFree;
    };
    const labelPositionOrtho = (param) => {
        let allChecked = true;
        if (multi_selected_links.current.length != 0) {
            switch (param) {
                case 'above':
                    multi_selected_links.current.map(d => {
                        allChecked = (d.orthogonal_label_position == 'above') ? allChecked : false;
                    });
                    break;
                case 'middle':
                    multi_selected_links.current.map(d => {
                        allChecked = (d.orthogonal_label_position == 'middle') ? allChecked : false;
                    });
                    break;
                case 'below':
                    multi_selected_links.current.map(d => {
                        allChecked = (d.orthogonal_label_position == 'below') ? allChecked : false;
                    });
                    break;
            }
            return allChecked;
        }
        else {
            return false;
        }
    };
    //Onglet Tags du menu noeud pour selectionner un tag favorie si présent
    const link_tag = (react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: "tags", title: "\u00C9tiquettes", disabled: /*node.colorParameter !== 'groupTag'*/ false },
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Groupe d'\u00E9tiquettes:")),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 6 },
                react_1.default.createElement(react_bootstrap_1.Form.Select, { onChange: (evt) => set_tags_group_key(evt.target.value) }, Object.entries(fluxTags).map((tags_group, i) => react_1.default.createElement("option", { key: i, value: tags_group[0], selected: tags_group_key === tags_group[0] }, tags_group[1].group_name))))),
        //Définition des valeurs selon les paramètre dataTags
        Object.entries(data.dataTags).map(([dataTagKey, dataTag]) => {
            if (Object.keys(dataTag.tags).length != 0) {
                return (react_1.default.createElement(react_bootstrap_1.Row, { key: dataTagKey },
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_bootstrap_1.FormLabel, null,
                            dataTag.group_name,
                            " :")),
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_bootstrap_1.Form.Select, { name: dataTagKey, value: tags_selected[dataTagKey], onChange: (evt) => {
                                //Modifie les paramètres selectionnés 
                                const { name, value } = evt.target;
                                set_tags_selected(prevState => (Object.assign(Object.assign({}, prevState), { [name]: value })));
                            } }, Object.entries(dataTag.tags).map(([tag_key, tag]) => {
                            return (react_1.default.createElement("option", { key: tag.name, value: tag_key }, tag.name));
                        })))));
            }
        }),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { xs: 12, as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Table, { striped: true, bordered: true, hover: true, className: 'link_tags_affiliation' },
                react_1.default.createElement("thead", null,
                    react_1.default.createElement("tr", null,
                        react_1.default.createElement("th", null, "Nom"),
                        react_1.default.createElement("th", null, "Appartenance"))),
                react_1.default.createElement("tbody", null, tags_visible && tags_group_key != '' && Object.keys(fluxTags).includes(tags_group_key) ? Object.entries(fluxTags[tags_group_key].tags).map(([tag_key, tag]) => {
                    return (react_1.default.createElement("tr", { key: tag_key },
                        react_1.default.createElement("td", null,
                            react_1.default.createElement(react_bootstrap_1.FormLabel, null, tag.name)),
                        react_1.default.createElement("td", null,
                            react_1.default.createElement(react_bootstrap_1.FormCheck, { name: 'element_visible' + tag_key, checked: value_selected_parameter().tags[tags_group_key] === tag_key, id: tag_key, type: 'checkbox', onChange: (evt) => {
                                    const new_nb_element = evt.target;
                                    const new_tag_key = new_nb_element.id;
                                    const visible = new_nb_element.checked;
                                    Object.values(data.links).filter(f => multi_selected_links.current.map(d => d.idLink).includes(f.idLink)).map(d => {
                                        let val = Object(d.value);
                                        Object.values(tags_selected).forEach(tag => {
                                            if (val[tag] === undefined) {
                                                val[tag] = {};
                                            }
                                            val = val[tag];
                                        });
                                        val.tags[tags_group_key] = visible ? new_tag_key : '';
                                    });
                                    set_data(Object.assign({}, data));
                                } }))));
                }) : (react_1.default.createElement(react_1.default.Fragment, null)))))));
    return (react_1.default.createElement(react_bootstrap_1.Row, null,
        react_1.default.createElement(react_bootstrap_1.Col, { sm: 12 },
            react_1.default.createElement(react_bootstrap_1.Tabs, { defaultActiveKey: "flux_data", id: "settings-layout" },
                react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: "flux_data", title: "Donn\u00E9es" },
                    react_1.default.createElement(react_bootstrap_1.Form, null,
                        //Définition des valeurs selon les paramètre dataTags
                        Object.entries(data.dataTags).map(([dataTagKey, dataTag]) => {
                            if (Object.keys(dataTag.tags).length != 0) {
                                // console.log(dataTagKey)
                                // console.log(tags_selected)
                                return (react_1.default.createElement(react_bootstrap_1.Row, { key: dataTagKey },
                                    react_1.default.createElement(react_bootstrap_1.Col, null,
                                        react_1.default.createElement(react_bootstrap_1.FormLabel, null,
                                            dataTag.group_name,
                                            " :")),
                                    react_1.default.createElement(react_bootstrap_1.Col, null,
                                        react_1.default.createElement(react_bootstrap_1.Form.Select, { name: dataTagKey, value: tags_selected[dataTagKey], onChange: (evt) => {
                                                //Modifie les paramètres selectionnés 
                                                const { name, value } = evt.target;
                                                set_tags_selected(prevState => (Object.assign(Object.assign({}, prevState), { [name]: value })));
                                            } }, Object.entries(dataTag.tags).map(([tag_key, tag]) => {
                                            return (react_1.default.createElement("option", { key: tag.name, value: tag_key }, tag.name));
                                        })))));
                            }
                        }),
                        react_1.default.createElement(react_bootstrap_1.Row, null,
                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Valeur pour ces param\u00E8tres")),
                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: 'text', value: test_value(value_selected_parameter().value), onChange: evt => {
                                        if (evt.target.value !== '' && !isNaN(+evt.target.value)) {
                                            const was_empty = test_value(value_selected_parameter().value) === '';
                                            let val = Object(selected_link.current.value);
                                            multi_selected_links.current.map(d => {
                                                d.dashed = !was_empty;
                                                val = d.value;
                                                Object.values(tags_selected).forEach(tag => {
                                                    if (val[tag] === undefined) {
                                                        val[tag] = {};
                                                    }
                                                    val = val[tag];
                                                });
                                                val.value = +evt.target.value;
                                            });
                                        }
                                        else {
                                            let val = Object(selected_link.current.value);
                                            multi_selected_links.current.map(d => {
                                                val = d.value;
                                                d.dashed = true;
                                                Object.values(tags_selected).forEach(tag => {
                                                    if (val[tag] === undefined) {
                                                        val[tag] = {};
                                                    }
                                                    val = val[tag];
                                                });
                                                val.value = '';
                                            });
                                        }
                                        set_data(Object.assign({}, data));
                                    } }))),
                        react_1.default.createElement(react_bootstrap_1.Row, null,
                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Affichage")),
                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: 'text', value: value_selected_parameter().display_value, onChange: evt => {
                                        let val = Object(selected_link.current.value);
                                        multi_selected_links.current.map(d => {
                                            val = d.value;
                                            Object.values(tags_selected).forEach(tag => {
                                                if (val[tag] === undefined) {
                                                    val[tag] = {};
                                                }
                                                val = val[tag];
                                            });
                                            val.display_value = evt.target.value;
                                        });
                                        set_data(Object.assign({}, data));
                                    } }))))),
                react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: "flux_attributes", title: "Apparence" },
                    react_1.default.createElement(react_bootstrap_1.Form, null,
                        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Couleur:")),
                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "color", value: (multi_selected_links.current.length == 1) ? multi_selected_links.current[0].color : '#ffffff', onChange: evt => {
                                        // selected_link.current.color = evt.target.value
                                        const color = evt.target.value;
                                        multi_selected_links.current.map(d => d.color = evt.target.value);
                                        Object.values(data.links).filter(f => multi_selected_links.current.map(d => d.idLink).includes(f.idLink)).map(d => d.color = color);
                                        set_data(Object.assign({}, data));
                                    } }))),
                        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Gradient:")),
                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                react_1.default.createElement(react_bootstrap_1.Form.Check, { inline: true, type: "checkbox", checked: gradChecked(), onChange: evt => {
                                        // selected_link.gradient = evt.target.checked
                                        Object.values(data.links).filter(f => multi_selected_links.current.map(d => d.idLink).includes(f.idLink)).map(d => d.gradient = evt.target.checked);
                                        set_data(Object.assign({}, data));
                                    } }))),
                        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Hachur\u00E9:")),
                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                react_1.default.createElement(react_bootstrap_1.Form.Check, { inline: true, type: "checkbox", checked: dashChecked(), onChange: evt => {
                                        // selected_link.gradient = evt.target.checked
                                        Object.values(data.links).filter(f => multi_selected_links.current.map(d => d.idLink).includes(f.idLink)).map(d => d.dashed = evt.target.checked);
                                        set_data(Object.assign({}, data));
                                    } }))),
                        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Orientation flux:"))),
                        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                            react_1.default.createElement(react_bootstrap_1.Col, { sm: 3 },
                                react_1.default.createElement(react_bootstrap_1.FormCheck, { name: 'orientation', type: 'radio', label: 'Horiz-Horiz', value: 'hh', checked: linkOrientation('hh'), onChange: evt => {
                                        Object.values(data.links).filter(f => multi_selected_links.current.map(d => d.idLink).includes(f.idLink)).map(d => {
                                            d.orientation = evt.target.value;
                                        });
                                        set_data(Object.assign({}, data));
                                    } })),
                            react_1.default.createElement(react_bootstrap_1.Col, { sm: 3 },
                                react_1.default.createElement(react_bootstrap_1.FormCheck, { name: 'orientation', type: 'radio', label: 'Vert-Vert', value: 'vv', checked: linkOrientation('vv'), onChange: evt => {
                                        Object.values(data.links).filter(f => multi_selected_links.current.map(d => d.idLink).includes(f.idLink)).map(d => {
                                            d.orientation = evt.target.value;
                                        });
                                        set_data(Object.assign({}, data));
                                    } })),
                            react_1.default.createElement(react_bootstrap_1.Col, { sm: 3 },
                                react_1.default.createElement(react_bootstrap_1.FormCheck, { name: 'orientation', type: 'radio', label: 'Vert-Horiz', value: 'vh', checked: linkOrientation('vh'), onChange: evt => {
                                        Object.values(data.links).filter(f => multi_selected_links.current.map(d => d.idLink).includes(f.idLink)).map(d => {
                                            d.orientation = evt.target.value;
                                        });
                                        set_data(Object.assign({}, data));
                                    } })),
                            react_1.default.createElement(react_bootstrap_1.Col, { sm: 3 },
                                react_1.default.createElement(react_bootstrap_1.FormCheck, { name: 'orientation', type: 'radio', label: 'Horiz-Vert', value: 'hv', checked: linkOrientation('hv'), onChange: evt => {
                                        Object.values(data.links).filter(f => multi_selected_links.current.map(d => d.idLink).includes(f.idLink)).map(d => {
                                            d.orientation = evt.target.value;
                                        });
                                        set_data(Object.assign({}, data));
                                    } }))),
                        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Position du centre")),
                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                react_1.default.createElement(react_bootstrap_1.FormControl, { min: 0, max: 1, step: 0.01, type: 'number', value: shiftCenter(), disabled: (linkOrientation('hv') || linkOrientation('vh')), onChange: evt => {
                                        Object.values(data.links).filter(f => multi_selected_links.current.map(d => d.idLink).includes(f.idLink)).map(d => {
                                            if (+evt.target.value - d.shift_gap < 0) {
                                                return;
                                            }
                                            if (+evt.target.value + d.shift_gap > 1) {
                                                return;
                                            }
                                            d.left_horiz_shift = +evt.target.value - d.shift_gap;
                                            d.right_horiz_shift = +evt.target.value + d.shift_gap;
                                        });
                                        set_data(Object.assign({}, data));
                                    } })),
                            react_1.default.createElement(react_bootstrap_1.Col, { sm: 2 }, selected_link.current.shift_gap)),
                        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Ecart entre Poign\u00E9es")),
                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                react_1.default.createElement(react_bootstrap_1.FormControl, { min: 0, max: 0.5, step: 0.01, type: 'number', value: shift(), disabled: (linkOrientation('hv') || linkOrientation('vh')), onChange: evt => {
                                        Object.values(data.links).filter(f => multi_selected_links.current.map(d => d.idLink).includes(f.idLink)).map(d => {
                                            if (center - +evt.target.value < 0) {
                                                return;
                                            }
                                            if (center + +evt.target.value > 1) {
                                                return;
                                            }
                                            d.shift_gap = +evt.target.value;
                                            d.left_horiz_shift = center - d.shift_gap;
                                            d.right_horiz_shift = center + d.shift_gap;
                                        });
                                        set_data(Object.assign({}, data));
                                    } })),
                            react_1.default.createElement(react_bootstrap_1.Col, { sm: 2 }, selected_link.current.shift_gap)),
                        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Type:")),
                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', label: 'Courbe', checked: linkType('courbe'), onChange: evt => {
                                        Object.values(data.links).filter(f => multi_selected_links.current.map(d => d.idLink).includes(f.idLink)).map(d => d.curved = evt.target.checked);
                                        set_data(Object.assign({}, data));
                                    } })),
                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', label: 'Fl\u00E8che', checked: linkType('arrow'), onChange: evt => {
                                        Object.values(data.links).filter(f => multi_selected_links.current.map(d => d.idLink).includes(f.idLink)).map(d => d.arrow = evt.target.checked);
                                        set_data(Object.assign({}, data));
                                    } })),
                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', label: 'Recyclage', checked: linkType('recycle'), onChange: evt => {
                                        Object.values(data.links).filter(f => multi_selected_links.current.map(d => d.idLink).includes(f.idLink)).map(d => {
                                            d.recycling = evt.target.checked;
                                            delete d.left_horiz_shift;
                                            delete d.right_horiz_shift;
                                        });
                                        set_data(Object.assign({}, data));
                                    } }))),
                        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Courbure")),
                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                react_1.default.createElement(react_bootstrap_1.FormControl, { min: 0, max: 1, step: 0.01, type: 'number', value: courbure(), onChange: evt => {
                                        Object.values(data.links).filter(f => multi_selected_links.current.map(d => d.idLink).includes(f.idLink)).map(d => {
                                            d.curvature = +evt.target.value;
                                        });
                                        set_data(Object.assign({}, data));
                                    } })),
                            react_1.default.createElement(react_bootstrap_1.Col, { sm: 2 }, selected_link.current.curvature)))),
                react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: "label", title: "Label" },
                    react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_bootstrap_1.FormCheck, { value: 'black', type: 'radio', label: 'Label en noir', checked: linkLabelColor('black'), onChange: (evt) => {
                                    Object.values(data.links).filter(f => multi_selected_links.current.map(d => d.idLink).includes(f.idLink)).map(d => {
                                        d.text_color = evt.target.value;
                                    });
                                    set_data(Object.assign({}, data));
                                } })),
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_bootstrap_1.FormCheck, { value: 'white', type: 'radio', label: 'Label blanc', checked: linkLabelColor('white'), onChange: (evt) => {
                                    Object.values(data.links).filter(f => multi_selected_links.current.map(d => d.idLink).includes(f.idLink)).map(d => {
                                        d.text_color = evt.target.value;
                                    });
                                    set_data(Object.assign({}, data));
                                } })),
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_bootstrap_1.FormCheck, { value: 'same_color', type: 'radio', label: 'Label en couleur', checked: linkLabelColor('color'), onChange: () => {
                                    Object.values(data.links).filter(f => multi_selected_links.current.map(d => d.idLink).includes(f.idLink)).map(d => {
                                        d.text_color = d.color;
                                    });
                                    set_data(Object.assign({}, data));
                                } }))),
                    react_1.default.createElement(react_bootstrap_1.Form.Group, null,
                        react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', label: 'Label visible', checked: labelVisibleChecked(), onChange: evt => {
                                Object.values(data.links).filter(f => multi_selected_links.current.map(d => d.idLink).includes(f.idLink)).map(d => {
                                    d.label_visible = evt.target.checked;
                                });
                                set_data(Object.assign({}, data));
                            } })),
                    react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', label: 'Aligner avec le chemin du flux', 
                                // disabled={selected_link.current.label_position === 'frozen'}
                                checked: labelSticktoLinkDisabled(), onChange: evt => {
                                    Object.values(data.links).filter(f => multi_selected_links.current.map(d => d.idLink).includes(f.idLink)).map(d => {
                                        d.label_on_path = evt.target.checked;
                                        d.label_position = (d.label_position == 'frozen') ? 'middle' : d.label_position;
                                        d.orthogonal_label_position = (d.orthogonal_label_position == 'frozen') ? 'middle' : d.orthogonal_label_position;
                                    });
                                    set_data(Object.assign({}, data));
                                } })),
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', label: 'Label Flux Libre', 
                                // disabled={selected_link.current.label_position === 'frozen'}
                                checked: labelLinkFree(), onChange: evt => {
                                    Object.values(data.links).filter(f => multi_selected_links.current.map(d => d.idLink).includes(f.idLink)).map(d => {
                                        d.label_on_path = (evt.target.checked) ? false : d.label_on_path;
                                        d.label_position = (evt.target.checked) ? 'frozen' : 'middle';
                                        d.orthogonal_label_position = (evt.target.checked) ? 'frozen' : 'middle';
                                    });
                                    set_data(Object.assign({}, data));
                                } }))),
                    react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Position laterale:")),
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_bootstrap_1.Form.Check, { value: 'beginning', type: 'radio', label: 'D\u00E9but', checked: labelPositionVert('beginning'), onChange: evt => {
                                    Object.values(data.links).filter(f => multi_selected_links.current.map(d => d.idLink).includes(f.idLink)).map(d => {
                                        d.label_position = evt.target.value;
                                        d.orthogonal_label_position = (d.orthogonal_label_position == 'frozen') ? 'middle' : d.orthogonal_label_position;
                                    });
                                    set_data(Object.assign({}, data));
                                } })),
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_bootstrap_1.Form.Check, { value: 'middle', type: 'radio', label: 'Milieu', checked: labelPositionVert('middle'), onChange: evt => {
                                    Object.values(data.links).filter(f => multi_selected_links.current.map(d => d.idLink).includes(f.idLink)).map(d => {
                                        d.label_position = evt.target.value;
                                        d.orthogonal_label_position = (d.orthogonal_label_position == 'frozen') ? 'middle' : d.orthogonal_label_position;
                                    });
                                    set_data(Object.assign({}, data));
                                } })),
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_bootstrap_1.Form.Check, { value: 'end', type: 'radio', label: 'Fin', checked: labelPositionVert('end'), onChange: evt => {
                                    Object.values(data.links).filter(f => multi_selected_links.current.map(d => d.idLink).includes(f.idLink)).map(d => {
                                        d.label_position = evt.target.value;
                                        d.orthogonal_label_position = (d.orthogonal_label_position == 'frozen') ? 'middle' : d.orthogonal_label_position;
                                    });
                                    set_data(Object.assign({}, data));
                                } }))),
                    react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Position orthogonale:")),
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_bootstrap_1.Form.Check, { value: 'below', type: 'radio', label: 'Dessous', checked: labelPositionOrtho('below'), onChange: evt => {
                                    Object.values(data.links).filter(f => multi_selected_links.current.map(d => d.idLink).includes(f.idLink)).map(d => {
                                        d.orthogonal_label_position = evt.target.value;
                                        d.label_position = (d.label_position == 'frozen') ? 'middle' : d.label_position;
                                    });
                                    set_data(Object.assign({}, data));
                                } })),
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_bootstrap_1.Form.Check, { value: 'middle', type: 'radio', label: 'Milieu', checked: labelPositionOrtho('middle'), onChange: evt => {
                                    Object.values(data.links).filter(f => multi_selected_links.current.map(d => d.idLink).includes(f.idLink)).map(d => {
                                        d.orthogonal_label_position = evt.target.value;
                                        d.label_position = (d.label_position == 'frozen') ? 'middle' : d.label_position;
                                    });
                                    set_data(Object.assign({}, data));
                                } })),
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_bootstrap_1.Form.Check, { value: 'above', type: 'radio', label: 'Dessus', checked: labelPositionOrtho('above'), onChange: evt => {
                                    Object.values(data.links).filter(f => multi_selected_links.current.map(d => d.idLink).includes(f.idLink)).map(d => {
                                        d.orthogonal_label_position = evt.target.value;
                                        d.label_position = (d.label_position == 'frozen') ? 'middle' : d.label_position;
                                    });
                                    set_data(Object.assign({}, data));
                                } })))),
                Object.keys(fluxTags).length > 0 ? link_tag : (react_1.default.createElement(react_1.default.Fragment, null)),
                react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: "flux_tooltip", title: "Info-bulle" },
                    react_1.default.createElement(react_bootstrap_1.Form, null,
                        react_1.default.createElement(react_bootstrap_1.Row, null,
                            react_1.default.createElement(react_bootstrap_1.FormLabel, { column: true, sm: 1 }, "Info-bulle:"),
                            react_1.default.createElement(react_bootstrap_1.Col, { sm: 11 },
                                react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", rows: 10, value: selected_link.current.tooltip_text ? selected_link.current.tooltip_text : '', onChange: evt => {
                                        selected_link.current.tooltip_text = evt.target.value;
                                        set_data(Object.assign({}, data));
                                    } }))))),
                children))));
};
SankeyLinkEdition.propTypes = SankeyLinkEditionPropTypes;
exports.default = SankeyLinkEdition;
